import request from '@/utils/request'

// 查询教师班级管理列表
export function listClasses(query) {
  return request({
    url: '/OmdTeacherClasses/classes/list',
    method: 'get',
    params: query
  })
}

// 查询教师班级管理详细
export function getClasses(id) {
  return request({
    url: '/OmdTeacherClasses/classes/' + id,
    method: 'get'
  })
}

// 新增教师班级管理
export function addClasses(data) {
  return request({
    url: '/OmdTeacherClasses/classes',
    method: 'post',
    data: data
  })
}

// 修改教师班级管理
export function updateClasses(data) {
  return request({
    url: '/OmdTeacherClasses/classes',
    method: 'put',
    data: data
  })
}

// 删除教师班级管理
export function delClasses(id) {
  return request({
    url: '/OmdTeacherClasses/classes/' + id,
    method: 'delete'
  })
}


export function delClassesteid(id) {
  return request({
    url: '/OmdTeacherClasses/classes/deleteted/' + id,
    method: 'delete'
  })
}
